export const getScheduleSelected = (scheduleSelected, programId) => {
    for (let i = 0; i < scheduleSelected.length; i++) {
        if (programId === scheduleSelected[i].programId) {
            return scheduleSelected[i].scheduleId
        }
    }

}